import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../axiosConfig';
import domain from '../../constants/config.js';

const apiDomain = domain.API_BASE_URL;

export const fetchBenefitDetails = createAsyncThunk(
  'benefitList/fetchBenefitDetails',
  async (planId) => {
    try {
      const apiUrl = `${apiDomain}v1/rsa-plans-benefits/${planId}`;
      const response = await api.get(apiUrl);
      console.log("API Response:", response.data);

      return response.data;
    } catch (error) {
      console.error("API Error in fetchBenefitDetails:", error);
      throw error;
    }
  }
);



const benefitDetailsSlice = createSlice({

  name: 'benefitList',
  initialState: {
    apiResponse: [],
    loading: false,
    apiErrorMsg: null,
    vehiclePlanId:null,
  },

  reducers: {
    setvehiclePlanId: (state, action) => {
      state.vehiclePlanId = action.payload;
    },
  },


  extraReducers: (builder) => {
    builder
      .addCase(fetchBenefitDetails.pending, (state) => {
        state.loading = true; // pending is triggered → sets loading = true
        // console.log("priceDetailsSlice",state.loading);
      })
      .addCase(fetchBenefitDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.apiResponse = action.payload; //API call completes → fulfilled sets list = response.data
        console.log("Reducer fetchBenefitDetails apiResponse",state.apiResponse);
      })
      .addCase(fetchBenefitDetails.rejected, (state, action) => {
        state.loading = false;
        state.apiErrorMsg = action.error.message; // If it fails → rejected sets error = message
      });
  },
});

export const { setvehiclePlanId } = benefitDetailsSlice.actions;

export default benefitDetailsSlice.reducer;
